import {checkImage}from './imageAuto.js';
import Util from './utils.js';
import lookImage from "../components/lookImage.vue";
import axios from 'axios';
import api from '../api';
import gql from 'graphql-tag';
// import konvaDraw from './konvaDraw.js';
export  const  lookPhoto = {
    data(){
        return{
            bigImageWidth:false,
            knowledgeDicData:{},
          //
          selected: true,
          selected2: false,
          // 对比图片时选择要编辑的图片
          imageCompileClass: 'left',
          imageCompileClass2: '',
          // 储存上次点击的图片对象
          activeImage: {},
          // 储存上次双击的图片对象
          activeImage2: {},
          // 单击延时器
          clickTimer: null,
          // 是否比较图片 1为不比较 2为比较
          isCompareImage: 1,
          largeImgage: "",
          // 要对比的图片路径
          largeImgage2: '',
          // 一开始点击的图片对象
          primevalImage: {},
          // 对比图片的数据
          compareImageList: [],
          // 是否含有编辑功能
          editStatus:false
        }
    },
    async created(){
        this.knowledgeDicData =await axios.request({
            method: 'get',
            url: api.knowledgeDic,
          })
    },
    components: {
        lookImage:lookImage
    },
    // mixins:[konvaDraw],
    methods: {
        async LookBigPhoto(imgPath, imgItem, id, type,type2){
          // 一开始点击的图片
          this.primevalImage = imgItem;
          this.activeImage = this.primevalImage;
          this.primevalImage.active = true;
          // 取其他图片列表
          if (type === 'hospitalized') { // 出入院图片对比
            const res = await this.$apollo.query({
              query: gql`{
                  hospitalization(id: ${id}){
                    id
                    image_hospitalization{
                      id
                      type
                      path
                      hospitalization_id
                    }
                  }
                }`,
              fetchPolicy: 'no-cache',
            });
            const hospitalizedData = res.data.hospitalization.image_hospitalization;
            for (const item of hospitalizedData) {
              if (item.id === imgItem.id) {
                item.active = true;
                this.activeImage = item;
              }
              item.thumbnailsImageSrc = api.hospitalization_imagesThumbnails + item.path;
              if (item.type === 1) {
                item.position_detail = '入院照片';
              } else if (item.type === 2) {
                item.position_detail = '出院照片';
              }
            }
            this.compareImageList = [{
              images: hospitalizedData,
              time: '',
            }]
          } else if (type === 'hairdressing') { // 美容图片对比
            try {
              const res = await this.$apollo.query({
                query: gql`{
                  patient(id: ${id}){
                    id
                    cosmetology{
                      id
                      treat_no
                      image_cosmetology{
                        id
                        path
                        created_time
                        status
                      }
                    }
                  }
                }`,
                fetchPolicy: "no-cache",
              });
              const hospitalizedData = res.data.patient.cosmetology;
              for (const item of hospitalizedData) {
                item.type = 'hairdressing';
                item.images = item.image_cosmetology;
                for (const imageItem of item.image_cosmetology) {
                  if (imageItem.id === imgItem.id) {
                    imageItem.active = true;
                    this.activeImage = imageItem;
                  }
                  imageItem.thumbnailsImageSrc = api.cosmetology_imagesThumbnails + imageItem.path;
                  imageItem.tplType = 'hairdressing';
                  if(type2 === 'hostoryList'){
                    imageItem.tplType2 = true;
                  }else{
                    imageItem.tplType2 = false;
                  }
                }
                /*if (item.id === imgItem.id) {
                  item.active = true;
                  this.activeImage = item;
                }
                item.thumbnailsImageSrc = api.cosmetology_imagesThumbnails + item.path;
                item.tplType = 'hairdressing';*/
              }
              this.compareImageList = hospitalizedData.filter((item) => {
                return item.image_cosmetology.length > 0;
              })
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
          } else { // 诊断影像图片对比
            try {
              const response = await this.$apollo.query({
                query: gql`query(
                  $id: Int!
                  $position: String!
                  $type: Int!
                ){
              patient(id: $id){
                id
                images(position: $position, type: $type){
                  id
                  path
                  diagnosis{
                    id
                    time
                  }
                  position_detail
                  origin
                  type
                }
              }
            }`,
                fetchPolicy: 'no-cache',
                variables: {
                  id,
                  position: imgItem.position_detail,
                  type: imgItem.type,
                }
              });
              const imagesList = response.data.patient.images;
              // 处理取到的数据
              for (let i = 0; i < imagesList.length; i++) {
                imagesList[i].time =  imagesList[i].diagnosis.time;
                imagesList[i].thumbnailsImageSrc = this.imageSrcPrefixThumbnails + imagesList[i].path;
                if (imgItem.id === imagesList[i].id) {
                  imagesList[i].active = true;
                  this.activeImage = imagesList[i];
                }
              }
              /* .filter(item => {
               return item.id !== imgItem.id;
             });*/
              let newImagesList = [];
              // 生成新的数据结构
              for (const img of imagesList) {
                const filterArr = newImagesList.filter(item => {
                  return item.time === img.time;
                });
                if (filterArr.length > 0) {
                  newImagesList[newImagesList.indexOf(filterArr[0])].images.push(img);
                } else {
                  newImagesList.push({
                    time: img.time,
                    images: [img],
                  })
                }
              }
              newImagesList = newImagesList.sort((a, b) => {
                return b.time - a.time;
              });
              this.compareImageList = newImagesList;
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
          }
          if (type === 'hospitalized') {
            this.largeImgage = api.hospitalization_images + imgPath;
          } else if (type === 'hairdressing') {
            this.largeImgage = api.cosmetology_images + imgPath;
          } else {
            this.largeImgage = Util.IMGPATHROOT + imgPath;
          }
          this.bigImageWidth = await checkImage(this.largeImgage);
          this.showLargeImage = true;
        },
         searchKnowledgeDic(ID){ // 根据id查病种
           if(!!ID){
               return this.knowledgeDicData.data[ID].name;
           }
        },
        // 修改是否含有编辑状态
        toggleEditStatus(status){
          this.$store.commit("setEditStatus",status);
          this.$store.commit("setEditimgId", null);
        },
      // 关闭大图时回调函数
      closeShowLargeImage(done) {
        done();
        this.isCompareImage = 1;
        this.toggleEditStatus(false);
      },
      // 对比图片时选择要编辑的图片
      checkImageCompile(checked) {
        if (checked) {
          this.imageCompileClass = 'left';
          this.imageCompileClass2 = '';
          this.selected = true;
          this.selected2 = false;
        } else {
          this.imageCompileClass = '';
          this.imageCompileClass2 = 'right';
          this.selected = false;
          this.selected2 = true;
        }
      },
      // 对比图片列表点击图片
      imageClick(data) {
        clearTimeout(this.clickTimer);
        this.clickTimer =  setTimeout(() => {
          if (this.isCompareImage === 1 && data.active === true) {
            return
          }
          this.isCompareImage = 1;
          this.$set(this.activeImage, 'active', false);
          this.$set(this.activeImage2, 'active', false);
          this.$set(data, 'active', true);
          this.activeImage = data;
          if (data.position_detail === '入院照片' || data.position_detail === '出院照片') {
            this.largeImgage = api.hospitalization_images + data.path;
          } else if (data.tplType === 'hairdressing') {
            this.largeImgage = api.cosmetology_images + data.path;
          } else {
            this.largeImgage = this.imageSrcPrefix + data.path;
          }
        }, 300);
      },
      // 对比图片列表双击图片
      imageDblclick(data) {
        clearTimeout(this.clickTimer);
        if (this.isCompareImage === 2) {
          return
        } else if (this.isCompareImage === 1 && data.active === true) {
          return
        }
        this.isCompareImage = 2;
        this.$set(data, 'active', true);
        if (data.position_detail === '入院照片' || data.position_detail === '出院照片') {
          this.largeImgage2 = api.hospitalization_images + data.path;
        } else if (data.tplType === 'hairdressing') {
          this.largeImgage2 = api.cosmetology_images + data.path;
        } else {
          this.largeImgage2 = this.imageSrcPrefix + data.path;
        }
        this.activeImage2 = data;
        // 初始化 选择左边的图片
        this.imageCompileClass = 'left';
        this.imageCompileClass2 = '';
        this.selected = true;
        this.selected2 = false;
      },
      // 查看大图左侧图片列表图片加载好后规定尺寸
      imageOnload(e) {
        const tag = e.target;
        if (tag.width / tag.height >= 160 / 130) {
          const newWidth = tag.width / (tag.height / 130);
          e.srcElement.style.height = '100%';
          e.srcElement.style.width = 'auto';
          const s = (newWidth - 160) / 2;
          e.srcElement.style.marginLeft = '-' + s + 'px';
          e.srcElement.style.marginTop = 0;
        } else {
          let newHeight = tag.height / (tag.width / 160);
          e.srcElement.style.width = '100%';
          e.srcElement.style.height = 'auto';
          const s = (newHeight - 130) / 2;
          e.srcElement.style.marginLeft = 0;
          e.srcElement.style.marginTop = '-' + s + 'px';
        }
      },
    },
  }
